import React from 'react'
import LoadingSplash from './LoadingSplash'

import { AppState } from 'helpers/context'

export default function asyncComponent(importComponent) {
  class AsyncComponent extends React.Component {
    state = {
      component: null
    }

    async componentDidMount() {
      this.props.startLoading()
      const { default: component } = await importComponent()

      this.props.stopLoading()
      this.setState({
        component: component
      })
    }

    componentWillUnmount() {
      this.props.stopLoading()
    }

    render() {
      const C = this.state.component

      return C ? <C {...this.props} /> : <LoadingSplash />
    }
  }

  return props => (
    <AppState.Consumer>
      {appState => (
        <AsyncComponent
          {...props}
          startLoading={appState.startLoading}
          stopLoading={appState.stopLoading}
        />
      )}
    </AppState.Consumer>
  )
}



// WEBPACK FOOTER //
// ./src/components/AsyncComponent.jsx